<template>
  <div class="file-upload-page">
    <a-card class="upload-card" title="文件上传">
      <!-- 上传区域 -->
      <a-upload-dragger
        name="file"
        :multiple="true"
        :action="uploadUrl"
        :before-upload="beforeUpload"
        :showUploadList="false"
      >
        <div class="upload-area">
          <p class="upload-area-icon">
            <a-icon type="inbox" />
          </p>
          <p class="ant-upload-text">将文件拖拽到此处或点击上传</p>
          <p class="ant-upload-hint">
            支持单个或批量上传，文件大小不能超过100M
          </p>
        </div>
      </a-upload-dragger>

      <!-- 上传注意事项 -->
      <div class="notice">
        <div class="notice-title">注意事项：</div>
        <ul class="notice-list">
          <li><strong>1.</strong> 不能以正斜线（/）或者反斜线（\）开头</li>
          <li><strong>2.</strong> 文件名不能包含"。"</li>
          <li><strong>3.</strong> 总文件不可超过100M,单个大文件请联系IT进行上传</li>
          <li><strong>4.</strong> 请勿上传压缩包</li>
        </ul>
      </div>
    </a-card>

    <!-- 文件列表表格 -->
    <a-card title="已上传文件" style="margin-top: 16px">
      <a-table
        class="file-table"
        :columns="columns"
        :dataSource="fileList"
        :pagination="false"
        :rowKey="record => record.uid"
        :locale="{ emptyText: '暂无上传文件' }"
      >
        <!-- 自定义文件名显示 -->
        <template slot="name" slot-scope="text, record">
          <span class="file-name">
            <a-icon :type="getFileIcon(record.type)" style="margin-right: 8px" />
            {{ text }}
          </span>
        </template>

        <!-- 自定义状态显示 -->
        <template slot="status" slot-scope="text, record">
          <a-tag :class="`status-${getStatusClass(record.status)}`">
            {{ getStatusText(record.status) }}
          </a-tag>
        </template>

        <!-- 错误信息 -->
        <template slot="errorMsg" slot-scope="text, record">
          <div v-if="record.errorMsg" class="error-msg">
            <a-icon type="close-circle" style="color: #f5222d; margin-right: 4px" />
            <span>{{ record.errorMsg }}</span>
          </div>
          <span v-else>-</span>
        </template>

        <!-- 自定义操作列 -->
        <template slot="action" slot-scope="text, record">
          <a-button-group size="small">
            <!--            <a-button type="link" @click="handlePreview(record)" :disabled="record.status !== 'success'">-->
            <!--              预览-->
            <!--            </a-button>-->
            <a-button type="link" @click="handleDownload(record)" :disabled="record.status !== 'SUCCESS'">
              下载
            </a-button>
            <a-button type="link" danger @click="handleRemove(record)">
              删除
            </a-button>
          </a-button-group>
        </template>
      </a-table>

      <!-- 操作按钮放在表格下方 -->
      <div class="table-actions">
        <a-button
          v-for="config in uploadConfigs"
          :key="config.key"
          type="primary"
          :icon="config.icon"
          :title="config.tooltip"
          @click="triggerUpload(config.key)"
          :loading="uploading"
        >
          {{ config.label }}
        </a-button>
        <a-button @click="handleClearAll" :disabled="fileList.length === 0">
          清空列表
        </a-button>
        <span class="file-count">共 {{ fileList.length }} 个文件</span>
      </div>
    </a-card>
  </div>
</template>

<script>
export default {
  name: 'FileUpload',
  data() {
    // 安全地获取上传URL
    let uploadUrl = "/bms/bizBusinessinfo/batchUpload";
    if (window._CONFIG && window._CONFIG.domianURL) {
      uploadUrl = window._CONFIG.domianURL + uploadUrl;
    }

    return {
      uploadConfigs: [
        { key: 'TYPE1', label: '按保单号上传', icon: 'file-text', tooltip: '1234567890.pdf(保单号)' },// policy
        { key: 'TYPE2', label: '按保单号policy上传', icon: 'file-text',tooltip:  '123456policy.pdf(保单号policy)'},// policy+"policy"
        { key: 'TYPE3', label: '投保人组合字段上传', icon: 'file-text' ,tooltip:  '山东省财政厅鲁AF38337交强险2025保单.pdf(投保人车牌号险种年份保单)'}, // insure+car+insurance_name+年份+"保单"
        { key: 'TYPE5', label: '按车牌号保单上传', icon: 'car',tooltip:  '鲁A-12345保单.pdf(车牌地域编码-车牌编号保单)【交强、商业相同】' }, // 鲁A-xxxxx+"保单"格式
        { key: 'TYPE4', label: '按车牌号组合字段上传', icon: 'car' ,tooltip:  '鲁A12345-2026年交强险电子保单.pdf(车牌号-年份年险种电子保单)'},// car+"-"+年份+"年"+insurance_name+"电子保单"
        { key: 'TYPE6', label: '按险种名组合字段上传', icon: 'car' ,tooltip:  '交强险_鲁A12345_123456_任何字符.pdf(险种名称_车牌号_保单号_xxx.pdf)'},// insurance_name+"_"+car+"_"+policy+"-"+随意字符串
      ],

      uploading: false,
      fileList: [], // 初始化空数组
      uploadUrl: uploadUrl,
      currentUploadType: '', // 当前上传类型标记
      columns: [
        {
          title: '名称',
          dataIndex: 'name',
          key: 'name',
          scopedSlots: { customRender: 'name' },
          width: '25%'
        },
        {
          title: '类型',
          dataIndex: 'type',
          key: 'type',
          width: '15%'
        },
        {
          title: '文件大小',
          dataIndex: 'size',
          key: 'size',
          width: '15%'
        },
        {
          title: '状态',
          dataIndex: 'status',
          key: 'status',
          scopedSlots: { customRender: 'status' },
          width: '15%'
        },
        {
          title: '错误信息',
          dataIndex: 'errorMsg',
          key: 'errorMsg',
          width: '20%',
          scopedSlots: { customRender: 'errorMsg' }
        },
        {
          title: '操作',
          key: 'action',
          scopedSlots: { customRender: 'action' },
          width: '20%'
        }
      ],
      statusMap: {
        'WAITING': '等待上传',
        'UPLOADING': '上传中',
        'SUCCESS': '上传成功',
        'FAILED': '上传失败'
      },
      fileIcons: {
        'PDF文档': 'file-pdf',
        'Word文档': 'file-word',
        'Excel文档': 'file-excel',
        '图片': 'file-image',
        '压缩文件': 'file-zip',
        '文本文件': 'file-text',
        '未知类型': 'file'
      }
    }
  },
  methods: {
    // 获取状态类名
    getStatusClass(status) {
      switch(status) {
        case 'SUCCESS': return 'success';
        case 'UPLOADING': return 'uploading';
        case 'FAILED': return 'error';
        case 'WAITING': return 'waiting';
        default: return 'waiting';
      }
    },

    // 获取状态文本
    getStatusText(status) {
      return this.statusMap[status] || status;
    },

    // 获取文件图标
    getFileIcon(fileType) {
      if (!fileType) return 'file';

      for (let key in this.fileIcons) {
        if (fileType.includes(key)) {
          return this.fileIcons[key];
        }
      }
      return 'file';
    },

    // 统一的上传触发方法
    async triggerUpload(uploadType) {
      this.currentUploadType = uploadType;
      await this.doUpload();
    },

    // 替换现有的 doUpload 方法
    async doUpload() {

      if (!Array.isArray(this.fileList)) {
        console.error('fileList 不是数组:', this.fileList);
        this.fileList = []; // 初始化为空数组
      }

      console.log('=== doUpload 开始执行 ===');
      console.log('当前文件列表:', this.fileList);
      console.log('文件列表长度:', this.fileList.length);

      // 安全检查fileList
      if (!this.fileList || this.fileList.length === 0) {
        console.log('条件1触发: 文件列表为空');
        this.$message.warning('请先选择要上传的文件');
        return;
      }

      // 检查是否有需要上传的文件
      const filesToUpload = this.fileList.filter(function(file) {
        return file.status !== 'SUCCESS' && file.status !== 'UPLOADING';
      });

      if (filesToUpload.length === 0) {
        this.$message.info('没有需要上传的新文件');
        return;
      }

      this.uploading = true;

      // 批量更新待上传文件状态为"上传中"
      filesToUpload.forEach(file => file.status = 'UPLOADING');

      try {
        const response = await this.uploadToAliyunOSS(filesToUpload, this.currentUploadType);

        console.log('后端返回结果:', response);

        if (response && response.code === 200 && response.result) {
          const batchResult = response.result;
          const fileResults = batchResult.fileResults || [];

          // 建立文件名到结果的映射
          const resultMap = {};
          fileResults.forEach(function(result) {
            if (result.originalFilename) {
              const key = result.originalFilename;
              resultMap[key] = result; // 原始文件名

              // 同时添加去掉扩展名的版本
              const keyWithoutExt = key.replace(/\.\w+$/, '');
              if (keyWithoutExt !== key) {
                resultMap[keyWithoutExt] = result;
              }

              console.log('添加映射:', key, '和', keyWithoutExt);
            }
          });

          // 更新文件状态
          let successCount = 0;
          let failedCount = 0;

          // 在构建 resultMap 后添加
          console.log('=== 后端返回的数据 ===');
          console.log('fileResults:', fileResults);
          console.log('resultMap 构建结果:');
          Object.keys(resultMap).forEach(key => {
            console.log(`  "${key}" ->`, resultMap[key]);
          });

          // 在文件处理前添加
          console.log('=== 前端文件列表 ===');

          filesToUpload.forEach(file => {

            console.log(`  "${file.name}" -> 去掉扩展名: "${file.name.replace(/\.[^/.]+$/, '')}"`);

            const fileNameWithoutExt = file.name.replace(/\.[^/.]+$/, '');
            const result = resultMap[fileNameWithoutExt];

            console.log('=== 开始处理文件 ===');
            console.log('文件名:', file.name);
            console.log('resultMap 中查找键名:', file.name);
            console.log('查找结果:', result);
            console.log('resultMap 所有键名:', Object.keys(resultMap));


            if (result) {
              // 1. 统一状态值
              const isSuccess = result.status === 'SUCCESS' || result.status === 'success';
              file.status = isSuccess ? 'SUCCESS' : 'FAILED';

              file.errorMsg = result.errorMessage || '';

              // 添加调试日志（可以加在这里）
              console.log('文件名:', file.name);
              console.log('后端返回的errorMessage:', result.errorMessage);
              console.log('file.errorMsg赋值后:', file.errorMsg);
              console.log('文件状态:', file.status);

              file.queryKey = result.queryKey || '';
              file.fileUrl = result.fileUrl || '';

              if (isSuccess) {
                successCount++;
              } else {
                failedCount++;
              }
            } else {
              // 如果没有找到对应的结果，标记为失败
              file.status = 'FAILED';
              file.errorMsg = '后端未返回该文件处理结果';
              failedCount++;
            }
          });

          // 显示总结信息
          /*if (successCount > 0 && failedCount > 0) {
            this.$message.success(`上传完成: 成功 ${successCount} 个, 失败 ${failedCount} 个`);
          } else if (successCount > 0) {
            this.$message.success(`成功上传 ${successCount} 个文件`);
          } else if (failedCount > 0) {
            this.$message.error(`${failedCount} 个文件上传失败`);
          }*/

        } else {
          // 处理错误响应
          const errorMsg = response && response.message ? response.message : '上传失败';
          // this.$message.error(errorMsg);

          filesToUpload.forEach(file => {
            file.status = 'FAILED';
            file.errorMsg = errorMsg;
          });
        }

      } catch (error) {
        // 网络错误等情况
        filesToUpload.forEach(file => {
          file.status = 'FAILED';
          file.errorMsg = error.message;
        });
        this.$message.error('上传请求失败: ' + error.message);
        console.error('批量上传出错', error);
      } finally {
        this.uploading = false;
        this.currentUploadType = '';
      }
    },

    // OSS上传函数
    async uploadToAliyunOSS(files, uploadType) {
      try {
        const formData = new FormData();

        // 批量追加所有文件
        files.forEach((file, index) => {
          const fileData = file.raw || file;
          formData.append('files', fileData);
        });

        // 公共参数
        formData.append('uploadType', uploadType);

        // 单次请求提交所有文件
        const response = await this.$http({
          url: this.uploadUrl,
          method: 'post',
          data: formData,
          headers: { 'Content-Type': 'multipart/form-data' }
        });

        console.log('后端返回结果:', response); // 调试日志

        if (response && response.data !== undefined) {
          return response.data;
        } else {
          // 有些库可能直接返回数据
          return response;
        }
      } catch (error) {
        throw new Error('上传失败: ' + (error.message || '网络错误'));
      }
    },

    // 上传前的校验
    beforeUpload(file) {
      var isLt5G = file.size / 1024 / 1024 / 1024 < 5;
      if (!isLt5G) {
        this.$message.error('文件大小不能超过5GB!');
        return false;
      }

      // 新增：压缩包格式校验（禁止上传压缩包）
      const zipExts = ['zip', 'rar', '7z', 'tar', 'gz', 'bz2']; // 常见压缩包格式，可按需补充
      const fileName = file.name;
      const ext = fileName.split('.').pop().toLowerCase(); // 获取文件后缀（小写，避免大小写问题）

      if (zipExts.includes(ext)) {
        this.$message.error(`禁止上传压缩包文件！`);
        return false; // 拦截上传
      }

      // 检查是否已存在同名文件
      const exists = this.fileList.some(f => f.name === fileName);
      if (exists) {
        this.$message.warning(`文件 ${fileName} 已存在`);
        return false;
      }

      // 添加到文件列表
      var fileType = this.getFileType(file.name);
      var fileSize = this.formatFileSize(file.size);

      // 确保fileList已初始化
      if (!this.fileList) {
        this.fileList = [];
      }

      const uid = Date.now() + '-' + Math.floor(Math.random() * 1000);

      this.fileList.push({
        uid: uid,
        name: file.name,
        type: fileType,
        size: fileSize,
        status: 'WAITING', // 初始状态为等待上传
        raw: file,
        errorMsg: '',
        queryKey: '',
        fileUrl: ''
      });

      this.$message.success(`已添加文件：${file.name}`);
      // 返回false手动控制上传
      return false;
    },

    // 根据文件名获取文件类型
    getFileType(fileName) {
      var parts = fileName.split('.');
      if (parts.length === 0) return '未知类型';

      var ext = parts[parts.length - 1].toLowerCase();
      var typeMap = {
        'pdf': 'PDF文档',
        'doc': 'Word文档',
        'docx': 'Word文档',
        'xls': 'Excel文档',
        'xlsx': 'Excel文档',
        'jpg': '图片',
        'jpeg': '图片',
        'png': '图片',
        'gif': '图片',
        'zip': '压缩文件',
        'rar': '压缩文件',
        'txt': '文本文件'
      };
      return typeMap[ext] || '未知类型';
    },

    // 格式化文件大小
    formatFileSize(bytes) {
      if (bytes === 0) return '0 B';
      var k = 1024;
      var sizes = ['B', 'KB', 'MB', 'GB'];
      var i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    },

    // 预览文件
    handlePreview(file) {
      console.log('预览文件:', file);
      this.$message.info('预览文件: ' + file.name);
      // 这里可以添加实际的预览逻辑
    },

    // 下载文件
    handleDownload(file) {
      if (!file.fileUrl) {
        this.$message.warning('文件URL不存在');
        return;
      }

      // 根据URL类型处理下载
      let fullUrl;
      if (file.fileUrl.startsWith('http')) {
        fullUrl = file.fileUrl;
      } else {
        fullUrl = (window._CONFIG && window._CONFIG.domianURL)
          ? window._CONFIG.domianURL + file.fileUrl
          : file.fileUrl;
      }

      window.open(fullUrl, '_blank');
      this.$message.success('开始下载文件');
    },

    // 删除文件
    handleRemove(file) {
      this.fileList = this.fileList.filter(function(item) {
        return item.uid !== file.uid;
      });
      this.$message.success('已删除文件: ' + file.name);
    },

    // 清空所有文件
    handleClearAll() {
      var _this = this;
      this.$confirm({
        title: '确认清空',
        content: '确定要清空所有文件吗？',
        onOk: function() {
          _this.fileList = [];
          _this.$message.success('已清空文件列表');
        }
      });
    }
  }
}
</script>

<style scoped>
.file-upload-page {
  padding: 16px;
  background-color: #f0f2f5;
  min-height: calc(100vh - 64px);
}

.upload-card {
  margin-bottom: 0;
}

/* 缩小后的上传区域样式（核心修改） */
.upload-area {
  border: 2px dashed #d9d9d9;
  border-radius: 6px;
  padding: 15px 10px; /* 原30px 20px，缩小内边距 */
  text-align: center;
  background-color: #fafafa;
  transition: border-color 0.3s;
  cursor: pointer;
  margin-bottom: 16px;
  width: 50%; /* 控制上传区域宽度（如50%、300px，按需调整） */
  margin-left: auto; /* 水平居中（可选，不想要居中可删除这两行） */
  margin-right: auto;
}

.upload-area:hover {
  border-color: #1890ff;
}

.upload-area-icon {
  font-size: 24px; /* 原40px，缩小图标 */
  color: #1890ff;
  margin-bottom: 8px; /* 原12px，缩小间距 */
}

.ant-upload-text {
  font-size: 14px; /* 原16px，缩小文字 */
  margin-bottom: 4px; /* 原8px，缩小间距 */
}

.ant-upload-hint {
  color: rgba(0, 0, 0, 0.45);
  font-size: 11px; /* 原默认，缩小提示文字 */
}

.notice {
  margin-top: 12px;
  padding: 12px;
  background-color: #fff2e8;
  border: 1px solid #ffbb96;
  border-radius: 6px;
  overflow: hidden; /* 避免横向排列溢出容器 */
}

.notice-title {
  font-weight: 500;
  color: #fa541c;
  margin-bottom: 8px; /* 增加标题与列表的间距，更美观 */
  font-size: 13px;
}

.notice-list {
  margin: 0;
  padding-left: 0; /* 清除默认左内边距（无需列表项缩进） */
  color: rgba(0, 0, 0, 0.65);
  font-size: 12px;
  display: flex; /* 开启 Flex 布局，子元素横向排列 */
  gap: 16px; /* 列表项之间的间距（按需调整，如12px、20px） */
  flex-wrap: wrap; /* 当屏幕变窄时，自动换行（避免溢出） */
}

.notice-list li {
  margin-bottom: 0; /* 清除默认底部间距（横向排列无需垂直间距） */
  list-style: none; /* 清除默认列表项符号（圆点） */
  display: flex; /* 让自定义符号与文字对齐 */
  align-items: center;
}

.file-table {
  background-color: #fff;
  margin-bottom: 16px;
}

.file-name {
  font-weight: 500;
  display: flex;
  align-items: center;
}

/* 错误信息样式 */
.error-msg {
  color: #f5222d;
  font-size: 12px;
  display: flex;
  align-items: center;
}

.status-success {
  color: #52c41a;
  background: #f6ffed;
  border-color: #b7eb8f;
}

.status-uploading {
  color: #1890ff;
  background: #e6f7ff;
  border-color: #91d5ff;
}

.status-error {
  color: #f5222d;
  background: #fff2f0;
  border-color: #ffccc7;
}

.status-waiting {
  color: #faad14;
  background: #fffbe6;
  border-color: #ffe58f;
}

.table-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  padding-top: 16px;
  border-top: 1px solid #f0f0f0;
  flex-wrap: wrap;
}

.file-count {
  margin-left: auto;
  color: rgba(0, 0, 0, 0.45);
  font-size: 13px;
}
</style>